/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerFindAllQueryResponse, TemplateQuestionTypesControllerFindAllQueryParams, TemplateQuestionTypesControllerFindAll401, TemplateQuestionTypesControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionTypesControllerFindAll";

function getTemplateQuestionTypesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-question-types` as const }  
  return res
}

/**
 * @summary Get all checklist template question types
 * {@link /api/v1/checklist-template-question-types}
 */
export async function templateQuestionTypesControllerFindAll(params?: TemplateQuestionTypesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionTypesControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindAll401 | TemplateQuestionTypesControllerFindAll403>, unknown>({ method : "GET", url : getTemplateQuestionTypesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}